module.exports = __webpack_public_path__ + "static/img/c1.ec60c8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/center/high-rise/c1.png
// module id = Cj9E
// module chunks = 0